if (!customElements.get('swiper-image-with-html')) {
    customElements.define(
        'swiper-image-with-html',
        class SwiperImageWithHtml extends HTMLElement {
            constructor() {
                super();
                this.swiperInstance = null;
                this.swiperEl = this.querySelector('.swiper');
            }

            connectedCallback() {
                const pagination = this.querySelector('.swiper-pagination');
                const nextBtn = this.querySelector('.swiper-button-next');
                const prevBtn = this.querySelector('.swiper-button-prev');
                this.swiperInstance = new Swiper(this.swiperEl, {
                    effect: 'fade',
                    loop: true,
                    autoplay: {
                        // delay: 3000,
                        // stopOnLastSlide: false,
                        disableOnInteraction: false,
                    },
                    fadeEffect: {
                        crossFade: true,
                    },
                    pagination: {
                        el: pagination,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    },
                });
            }

            disconnectedCallback() {
            }
        }
    );
}
